<cmps-task-list-task-marker
    class="cmps-cdk-flex-5 cmps-cdk-d-flex cmps-cdk-justify-content-center"
    [completed]="item?.completed"
    (click)="_onClick()"
></cmps-task-list-task-marker>
<cmps-task-list-task-title
    class="cmps-cdk-flex-65"
    [completed]="item?.completed"
    [editing]="item?.editing"
    [title]="item?.title"
    [msftTaskId]="item?.msftTaskId"
    (click)="_onClick()"
    (enter)="_onSaveClick()"
>
    <div cmpsTaskListTaskTitleLabel>
        {{ item?.title }}
    </div>
</cmps-task-list-task-title>
<div
    class="cmps-cdk-flex-30 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end cmps-cdk-pr-0dot5"
>
    <cmps-task-list-task-props
        class="cmps-cdk-d-flex"
        [overdue]="item?.overdue"
        [completed]="item?.completed"
        [dueDateTime]="item?.dueDateTime"
        [important]="item?.important"
        (dueDateTimeChange)="_onDueDateTimeChange($event)"
        (importanceClick)="_onImportanceClick()"
    ></cmps-task-list-task-props>
    <cmps-task-list-task-actions
        class="cmps-cdk-d-flex"
        [canEdit]="true"
        [editing]="item?.editing"
        (deleteClick)="_onDeleteClick()"
        (editClick)="_onEditClick()"
        (saveClick)="_onSaveClick()"
        (cancelEditClick)="_onCancelEditClick()"
    ></cmps-task-list-task-actions>
</div>
